// AutoCommentRules + CommentTemplates + CommentsBulk i18n fragment
const fragment = {
  vi: {
    // ── AutoCommentRules (acr) ──
    'acr.title': 'Auto-comment rules',
    'acr.subtitle':
      'Khi bạn đăng bài mới qua dashboard (FB Page / X / YouTube), hệ thống tự động schedule comment theo các rule active dưới đây.',

    'acr.action.cancel': 'Huỷ',
    'acr.action.createRule': 'Tạo rule',
    'acr.action.saveChanges': 'Lưu thay đổi',
    'acr.action.edit': 'Sửa',
    'acr.action.delete': 'Xoá',

    'acr.modal.createTitle': 'Tạo auto-comment rule',
    'acr.modal.editTitle': 'Sửa rule',

    'acr.field.name': 'Tên rule',
    'acr.field.namePlaceholder': 'VD: Auto-pin promo dưới mọi bài FB',
    'acr.field.platform': 'Nền tảng',
    'acr.field.accounts': 'Tài khoản áp dụng (để trống = áp dụng cho tất cả)',
    'acr.field.accountsPlaceholder': 'Tất cả tài khoản',
    'acr.field.templates': 'Templates dùng để comment (rotate qua từng template)',
    'acr.field.templatesPlaceholder': 'Chọn template...',
    'acr.field.noTemplatesPrefix': 'Chưa có template cho platform này. Vào',
    'acr.field.noTemplatesLink': 'Templates',
    'acr.field.noTemplatesSuffix': 'để tạo.',
    'acr.field.delays': 'Delays sau khi đăng bài (giây, phân cách bằng dấu phẩy)',
    'acr.field.delaysPlaceholder': 'VD: 600, 7200, 21600 (10p, 2h, 6h)',
    'acr.field.delaysHintPrefix': 'Mỗi delay tạo 1 comment. Tối thiểu 60s. Ví dụ:',
    'acr.field.delaysHintSuffix': '= comment sau 10p, 1h, 6h.',

    'acr.col.active': 'Bật',
    'acr.col.name': 'Tên rule',
    'acr.col.platform': 'Nền tảng',
    'acr.col.account': 'Account',
    'acr.col.templates': 'Templates',
    'acr.col.schedule': 'Lịch',
    'acr.col.triggered': 'Đã chạy',
    'acr.col.actions': 'Thao tác',

    'acr.empty.title': 'Chưa có rule nào',
    'acr.empty.desc': 'Tạo rule để tự động comment khi đăng bài mới',

    'acr.cell.allAccounts': 'Mọi account',
    'acr.cell.accountCount': '{count} account',
    'acr.cell.templateFallback': 'Template',
    'acr.cell.delayTooltip': '+{delay} sau khi đăng',
    'acr.cell.triggerCount': '{count} lần',

    'acr.confirm.deleteTitle': 'Xoá rule?',
    'acr.confirm.deleteDesc': 'Rule "{name}" sẽ bị xoá vĩnh viễn.',

    'acr.toast.nameRequired': 'Hãy nhập tên rule.',
    'acr.toast.templateRequired': 'Hãy chọn ít nhất 1 template.',
    'acr.toast.delayRequired': 'Hãy nhập ít nhất 1 delay hợp lệ (giây, ≥60).',
    'acr.toast.created': 'Đã tạo rule.',
    'acr.toast.updated': 'Đã cập nhật rule.',
    'acr.toast.saveFailed': 'Lưu thất bại.',
    'acr.toast.enabled': 'Đã bật rule.',
    'acr.toast.disabled': 'Đã tắt rule.',
    'acr.toast.deleted': 'Đã xoá rule.',

    // ── CommentTemplates (ctpl) ──
    'ctpl.title': 'Thư viện comment templates',

    'ctpl.platform.all': 'Tất cả nền tảng',
    'ctpl.platform.any': 'Mọi nền tảng',

    'ctpl.action.createTemplate': 'Tạo template',
    'ctpl.action.cancel': 'Huỷ',
    'ctpl.action.saveChanges': 'Lưu thay đổi',
    'ctpl.action.edit': 'Sửa',
    'ctpl.action.delete': 'Xoá',

    'ctpl.modal.createTitle': 'Tạo template mới',
    'ctpl.modal.editTitle': 'Sửa template',

    'ctpl.field.name': 'Tên template',
    'ctpl.field.namePlaceholder': 'VD: Cảm ơn khách hàng',
    'ctpl.field.platform': 'Nền tảng áp dụng',
    'ctpl.field.platformHint': 'Chọn "Mọi nền tảng" nếu template dùng được cho cả FB/X/YT.',
    'ctpl.field.content': 'Nội dung comment',
    'ctpl.field.contentPlaceholder': 'Nhập nội dung comment...',
    'ctpl.field.tags': 'Tags (phân cách bởi dấu phẩy)',
    'ctpl.field.tagsPlaceholder': 'vd: cam-on, promo, launch',

    'ctpl.filter.search': 'Tìm kiếm',
    'ctpl.filter.searchPlaceholder': 'Tên / nội dung / tag',
    'ctpl.filter.platform': 'Nền tảng',
    'ctpl.filter.apply': 'Lọc',
    'ctpl.filter.reset': 'Đặt lại',

    'ctpl.col.name': 'Tên',
    'ctpl.col.content': 'Nội dung',
    'ctpl.col.platform': 'Nền tảng',
    'ctpl.col.tags': 'Tags',
    'ctpl.col.usage': 'Dùng',
    'ctpl.col.actions': 'Thao tác',

    'ctpl.empty.title': 'Chưa có template nào',
    'ctpl.empty.desc': 'Tạo template để soạn comment nhanh hơn',

    'ctpl.confirm.deleteTitle': 'Xoá template?',
    'ctpl.confirm.deleteDesc': 'Template "{name}" sẽ bị xoá vĩnh viễn.',

    'ctpl.toast.nameRequired': 'Hãy nhập tên template.',
    'ctpl.toast.contentRequired': 'Hãy nhập nội dung.',
    'ctpl.toast.created': 'Đã tạo template.',
    'ctpl.toast.updated': 'Đã cập nhật.',
    'ctpl.toast.saveFailed': 'Lưu thất bại.',
    'ctpl.toast.deleted': 'Đã xoá template.',

    // ── CommentsBulk (cmtBulk) ──
    'cmtBulk.title': 'Bulk schedule comment',
    'cmtBulk.badge': 'Smart stagger',

    'cmtBulk.action.back': 'Quay lại',
    'cmtBulk.action.cancel': 'Huỷ',
    'cmtBulk.action.submit': 'Lên lịch {count} comment',

    'cmtBulk.howTo.title': 'Cách dùng',
    'cmtBulk.howTo.desc':
      '1) Chọn nền tảng + tài khoản. 2) Paste URL (1 dòng / 1 URL) và nội dung (1 dòng / 1 comment). 3) Chọn time window. Hệ thống tự rải đều theo thuật toán stagger có jitter ngẫu nhiên.',

    'cmtBulk.field.platform': 'Nền tảng',
    'cmtBulk.field.account': 'Tài khoản',
    'cmtBulk.field.urls': 'URL bài viết — 1 dòng / 1 URL ({count})',
    'cmtBulk.field.messages': 'Nội dung — 1 dòng / 1 comment ({count})',
    'cmtBulk.field.templateHint': 'Click template để thêm vào danh sách comment:',

    'cmtBulk.window.label': 'Time window — comment sẽ được rải trong khoảng này',
    'cmtBulk.window.start': 'Bắt đầu',
    'cmtBulk.window.end': 'Kết thúc',
    'cmtBulk.window.minInterval': 'Khoảng cách tối thiểu (giây)',

    'cmtBulk.stat.total': 'Tổng comment',
    'cmtBulk.stat.window': 'Window (phút)',
    'cmtBulk.stat.required': 'Cần tối thiểu',
    'cmtBulk.stat.average': 'Trung bình',
    'cmtBulk.stat.minutesShort': '{value}p',
    'cmtBulk.stat.perComment': '{value}p/cmt',

    'cmtBulk.warning.tooShort':
      'Window quá ngắn cho {count} comment với khoảng cách {interval}s. Cần ít nhất {minutes} phút.',

    'cmtBulk.preview.title': 'Preview lịch (jitter ±25% mỗi slot)',
    'cmtBulk.preview.url': 'URL',
    'cmtBulk.preview.content': 'Nội dung',
    'cmtBulk.preview.schedule': 'Schedule (dự kiến)',
    'cmtBulk.preview.more': '... và {count} comment khác',

    'cmtBulk.tooltip.needInput': 'Nhập URL + nội dung',
    'cmtBulk.tooltip.tooShort': 'Window quá ngắn',

    'cmtBulk.toast.platformRequired': 'Hãy chọn nền tảng.',
    'cmtBulk.toast.accountRequired': 'Hãy chọn tài khoản.',
    'cmtBulk.toast.itemsRequired': 'Hãy nhập URL và nội dung.',
    'cmtBulk.toast.windowRequired': 'Hãy chọn time window.',
    'cmtBulk.toast.windowLead': 'Window phải bắt đầu sau hiện tại ít nhất {minutes} phút.',
    'cmtBulk.toast.windowTooShort': 'Window quá ngắn — cần ít nhất {minutes} phút.',
    'cmtBulk.toast.scheduled': 'Đã lên lịch {count} comment.',
    'cmtBulk.toast.createFailed': 'Bulk create thất bại.',
  },
  en: {
    // ── AutoCommentRules (acr) ──
    'acr.title': 'Auto-comment rules',
    'acr.subtitle':
      'When you publish a new post via the dashboard (FB Page / X / YouTube), the system automatically schedules comments using the active rules below.',

    'acr.action.cancel': 'Cancel',
    'acr.action.createRule': 'Create rule',
    'acr.action.saveChanges': 'Save changes',
    'acr.action.edit': 'Edit',
    'acr.action.delete': 'Delete',

    'acr.modal.createTitle': 'Create auto-comment rule',
    'acr.modal.editTitle': 'Edit rule',

    'acr.field.name': 'Rule name',
    'acr.field.namePlaceholder': 'e.g. Auto-pin promo under every FB post',
    'acr.field.platform': 'Platform',
    'acr.field.accounts': 'Applied accounts (leave empty = apply to all)',
    'acr.field.accountsPlaceholder': 'All accounts',
    'acr.field.templates': 'Templates used to comment (rotates through each template)',
    'acr.field.templatesPlaceholder': 'Select template...',
    'acr.field.noTemplatesPrefix': 'No template for this platform yet. Go to',
    'acr.field.noTemplatesLink': 'Templates',
    'acr.field.noTemplatesSuffix': 'to create one.',
    'acr.field.delays': 'Delays after publishing (seconds, comma-separated)',
    'acr.field.delaysPlaceholder': 'e.g. 600, 7200, 21600 (10m, 2h, 6h)',
    'acr.field.delaysHintPrefix': 'Each delay creates one comment. Minimum 60s. Example:',
    'acr.field.delaysHintSuffix': '= comment after 10m, 1h, 6h.',

    'acr.col.active': 'Active',
    'acr.col.name': 'Rule name',
    'acr.col.platform': 'Platform',
    'acr.col.account': 'Account',
    'acr.col.templates': 'Templates',
    'acr.col.schedule': 'Schedule',
    'acr.col.triggered': 'Triggered',
    'acr.col.actions': 'Actions',

    'acr.empty.title': 'No rules yet',
    'acr.empty.desc': 'Create a rule to auto-comment when publishing new posts',

    'acr.cell.allAccounts': 'All accounts',
    'acr.cell.accountCount': '{count} accounts',
    'acr.cell.templateFallback': 'Template',
    'acr.cell.delayTooltip': '+{delay} after publishing',
    'acr.cell.triggerCount': '{count} times',

    'acr.confirm.deleteTitle': 'Delete rule?',
    'acr.confirm.deleteDesc': 'Rule "{name}" will be permanently deleted.',

    'acr.toast.nameRequired': 'Please enter a rule name.',
    'acr.toast.templateRequired': 'Please select at least 1 template.',
    'acr.toast.delayRequired': 'Please enter at least 1 valid delay (seconds, ≥60).',
    'acr.toast.created': 'Rule created.',
    'acr.toast.updated': 'Rule updated.',
    'acr.toast.saveFailed': 'Save failed.',
    'acr.toast.enabled': 'Rule enabled.',
    'acr.toast.disabled': 'Rule disabled.',
    'acr.toast.deleted': 'Rule deleted.',

    // ── CommentTemplates (ctpl) ──
    'ctpl.title': 'Comment templates library',

    'ctpl.platform.all': 'All platforms',
    'ctpl.platform.any': 'Any platform',

    'ctpl.action.createTemplate': 'Create template',
    'ctpl.action.cancel': 'Cancel',
    'ctpl.action.saveChanges': 'Save changes',
    'ctpl.action.edit': 'Edit',
    'ctpl.action.delete': 'Delete',

    'ctpl.modal.createTitle': 'Create new template',
    'ctpl.modal.editTitle': 'Edit template',

    'ctpl.field.name': 'Template name',
    'ctpl.field.namePlaceholder': 'e.g. Thank you, customer',
    'ctpl.field.platform': 'Applied platform',
    'ctpl.field.platformHint': 'Choose "Any platform" if the template works for FB/X/YT.',
    'ctpl.field.content': 'Comment content',
    'ctpl.field.contentPlaceholder': 'Enter comment content...',
    'ctpl.field.tags': 'Tags (comma-separated)',
    'ctpl.field.tagsPlaceholder': 'e.g. thank-you, promo, launch',

    'ctpl.filter.search': 'Search',
    'ctpl.filter.searchPlaceholder': 'Name / content / tag',
    'ctpl.filter.platform': 'Platform',
    'ctpl.filter.apply': 'Filter',
    'ctpl.filter.reset': 'Reset',

    'ctpl.col.name': 'Name',
    'ctpl.col.content': 'Content',
    'ctpl.col.platform': 'Platform',
    'ctpl.col.tags': 'Tags',
    'ctpl.col.usage': 'Used',
    'ctpl.col.actions': 'Actions',

    'ctpl.empty.title': 'No templates yet',
    'ctpl.empty.desc': 'Create a template to write comments faster',

    'ctpl.confirm.deleteTitle': 'Delete template?',
    'ctpl.confirm.deleteDesc': 'Template "{name}" will be permanently deleted.',

    'ctpl.toast.nameRequired': 'Please enter a template name.',
    'ctpl.toast.contentRequired': 'Please enter content.',
    'ctpl.toast.created': 'Template created.',
    'ctpl.toast.updated': 'Updated.',
    'ctpl.toast.saveFailed': 'Save failed.',
    'ctpl.toast.deleted': 'Template deleted.',

    // ── CommentsBulk (cmtBulk) ──
    'cmtBulk.title': 'Bulk schedule comment',
    'cmtBulk.badge': 'Smart stagger',

    'cmtBulk.action.back': 'Back',
    'cmtBulk.action.cancel': 'Cancel',
    'cmtBulk.action.submit': 'Schedule {count} comments',

    'cmtBulk.howTo.title': 'How to use',
    'cmtBulk.howTo.desc':
      '1) Choose platform + account. 2) Paste URLs (1 per line) and content (1 comment per line). 3) Choose a time window. The system spreads them evenly using a stagger algorithm with random jitter.',

    'cmtBulk.field.platform': 'Platform',
    'cmtBulk.field.account': 'Account',
    'cmtBulk.field.urls': 'Post URLs — 1 per line ({count})',
    'cmtBulk.field.messages': 'Content — 1 comment per line ({count})',
    'cmtBulk.field.templateHint': 'Click a template to add it to the comment list:',

    'cmtBulk.window.label': 'Time window — comments will be spread within this range',
    'cmtBulk.window.start': 'Start',
    'cmtBulk.window.end': 'End',
    'cmtBulk.window.minInterval': 'Minimum interval (seconds)',

    'cmtBulk.stat.total': 'Total comments',
    'cmtBulk.stat.window': 'Window (minutes)',
    'cmtBulk.stat.required': 'Minimum needed',
    'cmtBulk.stat.average': 'Average',
    'cmtBulk.stat.minutesShort': '{value}m',
    'cmtBulk.stat.perComment': '{value}m/cmt',

    'cmtBulk.warning.tooShort':
      'Window too short for {count} comments with a {interval}s interval. At least {minutes} minutes needed.',

    'cmtBulk.preview.title': 'Schedule preview (jitter ±25% per slot)',
    'cmtBulk.preview.url': 'URL',
    'cmtBulk.preview.content': 'Content',
    'cmtBulk.preview.schedule': 'Schedule (estimated)',
    'cmtBulk.preview.more': '... and {count} more comments',

    'cmtBulk.tooltip.needInput': 'Enter URLs + content',
    'cmtBulk.tooltip.tooShort': 'Window too short',

    'cmtBulk.toast.platformRequired': 'Please choose a platform.',
    'cmtBulk.toast.accountRequired': 'Please choose an account.',
    'cmtBulk.toast.itemsRequired': 'Please enter URLs and content.',
    'cmtBulk.toast.windowRequired': 'Please choose a time window.',
    'cmtBulk.toast.windowLead': 'Window must start at least {minutes} minutes from now.',
    'cmtBulk.toast.windowTooShort': 'Window too short — at least {minutes} minutes needed.',
    'cmtBulk.toast.scheduled': 'Scheduled {count} comments.',
    'cmtBulk.toast.createFailed': 'Bulk create failed.',
  },
};

export default fragment;
